import { Button, Space } from "antd";
import React from "react";
import { CgWebsite } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import { removeToken } from "../../helpers";
import logo from "../../images/logo.png"

const AppHeader = () => {
  const { user, setUser } = useAuthContext();
  const navigate = useNavigate();

  const handleLogout = () => {
    removeToken();
    setUser(undefined);
    navigate("/signin", { replace: true });
  };

  return (
    <Space className="header_space" style={{backgroundColor:'#001529'}}>
      <Button className="header_space_brand" href="/" type="link">
         <img src={logo} width={100} height={16} />
      </Button>
      <Space className="auth_buttons">
        {user ? (
          <>
            <span> {user.username}</span>
            <Button
             style={{display:'none'}}
              className="auth_button_signUp"
              type="primary"
              onClick={handleLogout}
            >
              Salir
            </Button>
          </>
        ) : (
          <>
            <Button className="auth_button_signUp" href="/signin" type="primary">
              Acceso
            </Button>
          </>
        )}
      </Space>
    </Space>
  );
};

export default AppHeader;
